import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import DevicesLogedinList from './list';

const Devices = () => {
    return (
        <>
        <Box>
           <Stack gap={1} alignItems={"center"} mb={3}>
        <Typography variant="h1" color="initial">
        Devices logged in
        </Typography>
        <Typography variant="body2" color="initial">
        Access your device settings to personalize your experience and manage configurations
        </Typography>
      </Stack>
      <Stack gap={2} sx={{ maxWidth: 800, mx: 'auto' }}>
        <DevicesLogedinList />
      </Stack>
      </Box>
        </>
    );
};

export default Devices;
